module.exports = __webpack_public_path__ + "static/media/mode22.34497768.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode22.gif
// module id = 1450
// module chunks = 110